import { Routes } from '@angular/router';
import { AteneiComponent } from './atenei/atenei.component';
import { DipartimentiComponent } from './dipartimenti/dipartimenti.component';

import { FullComponent } from './layouts/full/full.component';

import { ReferenteComponent } from './referente/referente.component';
import { RuoloComponent } from './ruolo/ruolo.component';
import { SettoreScientificoComponent } from './settore-scientifico/settore-scientifico.component';
import { UtentiComponent } from './utenti/utenti.component';
import { AuthGuard } from './auth.guard';
import { PeriodiComponent } from './periodi/periodi.component';
import { BilanciComponent } from './bilanci/bilanci.component';
import { LoginComponent } from './login/login.component';
import { GestisciAdesioniComponent } from './gestisci-adesioni/gestisci-adesioni.component';
import { GestisciRicevuteComponent } from './gestisci-ricevute/gestisci-ricevute.component';
import { SociPagantiComponent } from './soci-paganti/soci-paganti.component';
import { PresidentiComponent } from './presidenti/presidenti.component';
import { NomenuComponent } from './layouts/nomenu/nomenu.component';
import { ProfiloComponent } from './profilo/profilo.component';
import { RichiestaAdesioneComponent } from './dashboard/richiesta-adesione/richiesta-adesione.component';
import { RiepilogoRichiestaAdesioneComponent } from './dashboard/riepilogo-richiesta-adesione/riepilogo-richiesta-adesione.component';
import { ModalitaDiPagamentoComponent } from './dashboard/modalita-di-pagamento/modalita-di-pagamento.component';
import { ConsultazioneBilanciComponent } from './dashboard/consultazione-bilanci/consultazione-bilanci.component';
import { AccediComponent } from './accedi/accedi.component';
import { AccessoComponent } from './accesso/accesso.component';
import { RecuperaPasswordComponent } from './recupera-password/recupera-password.component';
import { ImpostapasswordperaccessoComponent } from './impostapasswordperaccesso/impostapasswordperaccesso.component';
import { PaginaDiProvaComponent } from './pagina-di-prova/pagina-di-prova.component';
import { PagamentoOkComponent } from './dashboard/modalita-di-pagamento/pagamento-ok/pagamento-ok.component';
import { PagamentoAnnullatoComponent } from './dashboard/modalita-di-pagamento/pagamento-annullato/pagamento-annullato.component';
import { NuovaPasswordComponent } from './nuova-password/nuova-password.component';
import { RichiestaDiAdesioneComponent } from './dashboard/richiesta-di-adesione/richiesta-di-adesione.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { VisualizzaDettaglioTabellaComponent } from './dashboard/visualizza-dettaglio-tabella/visualizza-dettaglio-tabella.component';





export const AppRoutes: Routes = [
  {
    path: '',
    component: FullComponent,
    canActivate: [AuthGuard],
    children: [
     {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      /*{
        path: 'dashboard/:id',
        component: DashboardComponent,
      },*/
      {
        path: 'dashboard/richiesta-adesione',
        component: RichiestaAdesioneComponent,
      },
      {
        path: 'dashboard/richiesta-adesione/riepilogo-richiesta-adesione',
        component: RiepilogoRichiestaAdesioneComponent,
      },
      {
        path: 'dashboard/richiesta-adesione/riepilogo-richiesta-adesione/modalita-di-pagamento',
        component: ModalitaDiPagamentoComponent,
      },
      {
        path: 'bilanci',
        component: ConsultazioneBilanciComponent,
      },
      {
        path: 'dashboard/consultazione-bilanci',
        component: ConsultazioneBilanciComponent,
      },
      {
        path: 'dashboard/richiesta-adesione/riepilogo-richiesta-adesione/modalita-di-pagamento/pagamento-ok',
        component: PagamentoOkComponent,
      },
      {
        path: 'dashboard/richiesta-adesione/riepilogo-richiesta-adesione/modalita-di-pagamento/pagamento-annullato',
        component: PagamentoAnnullatoComponent,
      },
      {
        path: 'dashboard/richiesta-adesione/riepilogo-richiesta-adesione/modalita-di-pagamento/richiesta-di-adesione',
        component: RichiestaDiAdesioneComponent,
      },
      {
        path: 'visualizza-dettaglio-tabella/:id',
        component: VisualizzaDettaglioTabellaComponent,
      }
      /* {
        path: 'pagina-di-prova',
        component: PaginaDiProvaComponent,
      },*/
    ]
  },

  {
    path: '',
    component: NomenuComponent,
    children: [
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        path: 'profilo',
        component: ProfiloComponent,
      },
      {
        path: 'accedi',
        component: AccediComponent,
      },
      {
        path: 'accesso',
        component: AccessoComponent,
      },
      {
        path: 'recupera-password',
        component: RecuperaPasswordComponent,
      },
      {
        path: 'impostapasswordperaccesso',
        component: ImpostapasswordperaccessoComponent,
      },
    /*  {
        path: 'nuova-password',
        component: NuovaPasswordComponent,
      },*/
      {
        path: 'pagina-di-prova',
        component: PaginaDiProvaComponent,
      },
    ]
  },


  
];
